/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KuRelationshipType
 */
export interface KuRelationshipType {
    /**
     * 
     * @type {number}
     * @memberof KuRelationshipType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof KuRelationshipType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KuRelationshipType
     */
    textJa: string;
    /**
     * 
     * @type {string}
     * @memberof KuRelationshipType
     */
    textEn: string;
}

export function KuRelationshipTypeFromJSON(json: any): KuRelationshipType {
    return KuRelationshipTypeFromJSONTyped(json, false);
}

export function KuRelationshipTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): KuRelationshipType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'textJa': json['textJa'],
        'textEn': json['textEn'],
    };
}

export function KuRelationshipTypeToJSON(value?: KuRelationshipType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'textJa': value.textJa,
        'textEn': value.textEn,
    };
}


